import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Redirect } from '@avangard/utils/routing';
import { black } from '@avangard/ui/colors';
import { breakpoints } from '@avangard/ui/utils';

import { routes } from '@config/routes';
import { useCurrentUser } from '@modules/auth/hooks';
import { RequisitesEditForm } from '@modules/schools/organisms';

const RequisitesPage = (): React.ReactElement => {
    const { t } = useTranslation(['common', 'auth']);

    const { currentUser } = useCurrentUser();

    if (!currentUser.authenticated()) {
        return <Redirect noThrow to={routes.login.path} />;
    }

    if (
        !currentUser.isSchool() ||
        (currentUser.isSchool() && currentUser.school.requisites.isFilled())
    ) {
        return <Redirect noThrow to={routes.platform.path} />;
    }

    return (
        <>
            <Title>{t('auth:blocks.requisites.title')}</Title>

            <Description>{t('auth:blocks.requisites.description')}</Description>

            <RequisitesEditForm school={currentUser.school} />
        </>
    );
};

const Title = styled.p`
    font-size: 2.4rem;
    font-weight: 600;
    color: ${black[80]};
    margin-block-end: 8px;
    max-width: 540px;

    ${breakpoints.down('xs')} {
        font-size: 1.8rem;
    }
`;

const Description = styled.p`
    font-size: 1.4rem;
    font-weight: 600;
    color: ${black[40]};
    margin-block-end: 24px;

    ${breakpoints.down('xs')} {
        font-size: 1.2rem;
    }
`;

export { RequisitesPage };
